import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon, Text, useMultiStyleConfig } from '@chakra-ui/react';
import { routes } from 'app/routing/routesConfig';
import { PageWrapper } from 'app/components/Core';
import { ReactComponent as NotFoundIcon } from 'resources/images/ufo-404.svg';
import { useIsMobile } from 'app/utils/hooks';
import { useAppSelector } from 'app/store';
import { getAuthenticatedSelector } from 'app/store/Auth/selectors';

export const PageNotFound = () => {
  const isAuthenticated = useAppSelector(getAuthenticatedSelector);
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const styles = useMultiStyleConfig('NotFoundPage', { isMobile });

  const redirectToAuth = () => {
    navigate(routes.auth.path);
  };

  const redirectToSettings = () => {
    navigate(routes.settings.path);
  };

  return (
    <PageWrapper sx={styles.container}>
      <Icon role="img" boxSize="auto" as={NotFoundIcon} color="B.80" />
      <Text sx={styles.title} data-testid="empty-list-title">
        404
      </Text>
      <Text sx={styles.subtitle} data-testid="empty-list-message">
        Unfortunately, the page you are looking for&nbsp;
        <br />
        doesn&apos;t exist or may have been abducted…
      </Text>
      {!isAuthenticated && (
        <Button size="md" onClick={redirectToAuth} mt={6}>
          Get me out of here
        </Button>
      )}
      {isMobile && isAuthenticated && (
        <Button size="md" onClick={redirectToSettings} mt={6}>
          Take me to settings
        </Button>
      )}
    </PageWrapper>
  );
};
